import { useDispatch } from 'react-redux';
import { deleteCart } from '../../actions/cart';
import { formatDataTableValue } from '../../utils/functions';
import { premiumPaymentType } from '../../utils/variables';

export const formatValue = (inputValue, units) => {
  return formatDataTableValue({
    inputValue,
    isNumeric: false,
    isCurrency: true,
    isAbbrev: false,
    isLocalize: true,
    isPercent: false,
    units,
    showDataUnits: units,
    showEmptyIfNotValidNumber: true,
  }).dataValue;
};

// const dispatch = useDispatch();

// TODO: Add Logic for discount, waiver and apply that for total

export const getToolTipTitle = item => `Total Due is ${item.subTotal}`;

export const getOrderDiscount = () => {
  return formatValue(-0);
};

export const getWaiverAmount = () => {
  return formatValue(-0);
};

export const getDeliveryAmount = () => {
  return formatValue(0);
};

export const getItemsTotal = (cartTotal = 0) => {
  return formatValue(cartTotal);
};

export const getOrderTotal = (cartItems = []) => {
  let total = 0;
  cartItems.forEach(item => {
    total += item.subTotal;
  });
  return formatValue(total);
};

export const getTotalDue = ({ isLoan, isHealth, item }) => {
  if (isLoan || item?.isOutstandingAmount) return item.fullOutstandingAmount;
  if (isHealth) return item.subTotal || 0;
  if (item.premiumsDue > 0)
    return item.premiumsDue * (item.modalPremium || item.renewalPremium);
  if (item.fullOutstandingAmount && item.fullOutstandingAmount > 0)
    return item.fullOutstandingAmount;
  return undefined;
};

export const getPaymentSummary = (
  outstandingPaymentsQuantity,
  modalPremium,
  isAdvancedSelected,
  advancePaymentsQuantity,
) => {
  return `This payment applies to ${outstandingPaymentsQuantity || ''} ${
    outstandingPaymentsQuantity
      ? `outstanding premiums (${formatValue(
          outstandingPaymentsQuantity * modalPremium,
        )})`
      : ''
  }  ${isAdvancedSelected ? `and ${advancePaymentsQuantity}` : ''} ${
    isAdvancedSelected
      ? `advanced premiums (${formatValue(advancePaymentsQuantity * modalPremium)})`
      : ''
  }`;
};
